"use strict";

/* Стили */
import "../css/site.scss";

/* Скрипты */
import animateBlock from "./modules/animateBlock";
import bannerCounter from "./modules/bannerCounter";
import form from "./modules/form";
import { initAccordion } from './modules/accordion/init-accordion.js';
import initFilters from "./modules/init-filters";
import initPartnershipFilters from "./modules/initPartnershipFilters";
import site from "./modules/site";
import sliders from './modules/sliders/sliders';
import UtmTags from "./modules/UtmTags";
import clickChange from "./modules/clickChange";
import initShowMoreButton from "./modules/init-show-more-button";
import quiz from "./modules/quiz";
import { initTabs } from "./modules/tabs/init-tabs";
import noMoreFear from "./modules/noMoreFear.js";
import initChangeDate from "./modules/date/index.js";
import initWidjet from "./modules/init-widget.js";

document.addEventListener("DOMContentLoaded", () => {
  bannerCounter();
  UtmTags();
  initAccordion();
  animateBlock(".videos__slider-wrapper");
  animateBlock(".office__slides");
  site();
  form();
  sliders();
  initFilters();
  initPartnershipFilters();
  noMoreFear();
  clickChange('.programNew__point','.programNew__block');
  if (window.innerWidth <= 767){
    initShowMoreButton('[data-teachers]',0);
  }
  if (window.innerWidth > 767){
    initChangeDate();
  }
  quiz();
  initTabs();
  initWidjet();
});
